import { render } from "./catalogue-pin-group.vue?vue&type=template&id=72130448"
import script from "./catalogue-pin-group.vue?vue&type=script&lang=js"
export * from "./catalogue-pin-group.vue?vue&type=script&lang=js"

import "./catalogue-pin-group.vue?vue&type=style&index=0&id=72130448&lang=sass"

import exportComponent from "/Users/ohirjak/projects/mov-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__